var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleMapIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-map-icon_svg__clip0_4826_5647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.473.466A9.752 9.752 0 003.018 3.492l4.614 3.873 5.841-6.9z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.019 3.492A9.767 9.767 0 00.733 9.757c0 1.84.36 3.322.973 4.656l5.926-7.048L3.02 3.492z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.512 6.032a3.74 3.74 0 013.746 3.746 3.76 3.76 0 01-.89 2.413s2.943-3.514 5.82-6.921A9.75 9.75 0 0013.476.466l-5.842 6.9c.699-.805 1.715-1.334 2.879-1.334z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.51 13.503a3.74 3.74 0 01-3.746-3.746c0-.91.317-1.757.867-2.392l-5.925 7.048c1.015 2.243 2.709 4.063 4.444 6.328l7.217-8.572a3.715 3.715 0 01-2.857 1.334z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.24 23.111c3.26-5.1 7.048-7.407 7.048-13.333 0-1.63-.402-3.154-1.1-4.508L6.15 20.74c.55.72 1.122 1.546 1.672 2.392 1.99 3.07 1.439 4.89 2.709 4.89s.72-1.842 2.709-4.91z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google-map-icon_svg__clip0_4826_5647"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.733)",
    d: "M0 0h19.534v28H0z"
  })))));
}

export default SvgGoogleMapIcon;